var map = {
	"./amonkhet/theme.scss": 14,
	"./darkGreen/theme.scss": 15,
	"./darkRed/theme.scss": 16,
	"./eldrazi/theme.scss": 17,
	"./innistrad/theme.scss": 18,
	"./lightBlue/theme.scss": 19,
	"./material/theme.scss": 20,
	"./plain/theme.scss": 21
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;


//////////////////
// WEBPACK FOOTER
// ./src/styles/themes ^\.\/.*\/theme\.scss$
// module id = 148
// module chunks = 0